import React, { useState, useEffect } from 'react';
import { getPricingAll, createPricing, updatePricing, deletePricing } from '../api';

const empty = { category:'', name:'', price:'', is_featured:0, icon:'💰', tag:'', features:[], sort_order:0, is_active:1 };

const Modal = ({ title, onClose, children }) => (
  <div className="admin-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
    <div className="admin-modal">
      <div className="admin-modal-header">
        <h3>{title}</h3>
        <button className="admin-modal-close" onClick={onClose}>✕</button>
      </div>
      <div className="admin-modal-body">{children}</div>
    </div>
  </div>
);

const PricingAdmin = () => {
  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal]   = useState(null);
  const [form, setForm]     = useState(empty);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg]       = useState('');
  const [newFeat, setNewFeat] = useState('');

  const load = async () => {
    setLoading(true);
    const res = await getPricingAll();
    if (res.success) setItems(res.data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const openAdd  = () => { setForm(empty); setModal('add'); setMsg(''); };
  const openEdit = (p)  => { setForm({ ...p, features: p.features||[] }); setModal('edit'); setMsg(''); };
  const closeModal = () => { setModal(null); setForm(empty); };

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      const res = modal === 'add' ? await createPricing(form) : await updatePricing(form.id, form);
      if (res.success) { await load(); closeModal(); }
      else setMsg(res.message || 'Error saving.');
    } catch { setMsg('Network error.'); }
    setSaving(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this pricing plan?')) return;
    await deletePricing(id);
    await load();
  };

  const addFeature = () => {
    if (!newFeat.trim()) return;
    setForm(f => ({ ...f, features: [...f.features, { text: newFeat.trim(), ok: true }] }));
    setNewFeat('');
  };
  const removeFeature = (i) => setForm(f => ({ ...f, features: f.features.filter((_, idx) => idx !== i) }));
  const toggleFeatOk  = (i) => setForm(f => ({ ...f, features: f.features.map((fe, idx) => idx===i ? { ...fe, ok: !fe.ok } : fe) }));

  return (
    <div>
      <div className="admin-section-header">
        <h2>💰 Pricing Plans</h2>
        <button className="btn-admin-primary" onClick={openAdd}>+ Add Plan</button>
      </div>

      {loading ? <p>Loading...</p> : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr><th>#</th><th>Icon</th><th>Category</th><th>Plan Name</th><th>Price (₹)</th><th>Tag</th><th>Featured</th><th>Status</th><th>Actions</th></tr>
            </thead>
            <tbody>
              {items.map((p, i) => (
                <tr key={p.id}>
                  <td>{i + 1}</td>
                  <td style={{ fontSize: '1.4rem' }}>{p.icon}</td>
                  <td style={{ fontSize: '0.82rem', color: '#6c757d' }}>{p.category}</td>
                  <td style={{ fontWeight: 600 }}>{p.name}</td>
                  <td style={{ fontWeight: 700, color: '#ff6b35' }}>₹{p.price}</td>
                  <td><span style={{ background:'#e8eaff', color:'#1a1a5e', padding:'2px 10px', borderRadius:'50px', fontSize:'0.74rem', fontWeight:700 }}>{p.tag}</span></td>
                  <td>{p.is_featured ? <span className="status-badge status-active">⭐ Yes</span> : <span style={{ color:'#adb5bd', fontSize:'0.82rem' }}>No</span>}</td>
                  <td><span className={`status-badge ${p.is_active ? 'status-active' : 'status-inactive'}`}>{p.is_active ? 'Active' : 'Hidden'}</span></td>
                  <td>
                    <div className="actions">
                      <button className="btn-admin-primary btn-admin-sm" onClick={() => openEdit(p)}>✏️ Edit</button>
                      <button className="btn-admin-primary btn-admin-sm btn-admin-danger" onClick={() => handleDelete(p.id)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
              {!items.length && <tr><td colSpan={9} style={{ textAlign:'center', color:'#adb5bd', padding:'40px' }}>No pricing plans yet.</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {modal && (
        <Modal title={modal === 'add' ? '+ Add Pricing Plan' : '✏️ Edit Pricing Plan'} onClose={closeModal}>
          {msg && <div style={{ background:'#ffebee', color:'#c62828', padding:'10px 14px', borderRadius:'8px', marginBottom:'14px', fontSize:'0.85rem' }}>❌ {msg}</div>}
          <form onSubmit={handleSave}>
            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Category *</label>
                <input value={form.category} onChange={e => setForm({ ...form, category: e.target.value })} placeholder="Website Development" required />
              </div>
              <div className="admin-form-group">
                <label>Plan Name *</label>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Static Website" required />
              </div>
            </div>
            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Price (₹) *</label>
                <input value={form.price} onChange={e => setForm({ ...form, price: e.target.value })} placeholder="5,000" required />
              </div>
              <div className="admin-form-group">
                <label>Tag</label>
                <input value={form.tag} onChange={e => setForm({ ...form, tag: e.target.value })} placeholder="Starter / Popular / Advanced" />
              </div>
            </div>
            <div className="admin-form-row">
              <div className="admin-form-group">
                <label>Icon (emoji)</label>
                <input value={form.icon} onChange={e => setForm({ ...form, icon: e.target.value })} placeholder="💰" maxLength={5} />
              </div>
              <div className="admin-form-group">
                <label>Sort Order</label>
                <input type="number" value={form.sort_order} onChange={e => setForm({ ...form, sort_order: +e.target.value })} />
              </div>
            </div>

            {/* Features */}
            <div className="admin-form-group">
              <label>Features List</label>
              <div className="feature-list">
                {form.features.map((f, i) => (
                  <div key={i} className="feature-item">
                    <input type="checkbox" checked={f.ok} onChange={() => toggleFeatOk(i)} title="Checked = included (green ✓), unchecked = not included (red ✕)" />
                    <input type="text" value={f.text} onChange={e => setForm(fm => ({ ...fm, features: fm.features.map((fe, idx) => idx===i ? { ...fe, text: e.target.value } : fe) }))} />
                    <button type="button" className="remove-btn" onClick={() => removeFeature(i)}>✕</button>
                  </div>
                ))}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <input value={newFeat} onChange={e => setNewFeat(e.target.value)} placeholder="Add feature..." onKeyDown={e => e.key==='Enter' && (e.preventDefault(), addFeature())} style={{ flex:1, padding:'8px 12px', border:'1.5px solid #dee2e6', borderRadius:8, fontSize:'0.85rem' }} />
                <button type="button" className="btn-admin-primary btn-admin-sm" onClick={addFeature}>+ Add</button>
              </div>
            </div>

            <div style={{ display:'flex', gap:16, marginBottom:16 }}>
              <div className="admin-switch-row">
                <label className="admin-switch">
                  <input type="checkbox" checked={!!form.is_featured} onChange={e => setForm({ ...form, is_featured: e.target.checked ? 1 : 0 })} />
                  <span className="admin-slider"></span>
                </label>
                <span style={{ fontSize:'0.88rem', fontWeight:600 }}>⭐ Featured (orange highlight)</span>
              </div>
              <div className="admin-switch-row">
                <label className="admin-switch">
                  <input type="checkbox" checked={!!form.is_active} onChange={e => setForm({ ...form, is_active: e.target.checked ? 1 : 0 })} />
                  <span className="admin-slider"></span>
                </label>
                <span style={{ fontSize:'0.88rem', fontWeight:600 }}>Active</span>
              </div>
            </div>

            <div style={{ display:'flex', gap:10, marginTop:8 }}>
              <button type="submit" className="btn-admin-primary" disabled={saving} style={{ flex:1, justifyContent:'center', padding:'12px' }}>
                {saving ? '⏳ Saving...' : '💾 Save Plan'}
              </button>
              <button type="button" className="btn-admin-outline" onClick={closeModal}>Cancel</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
};

export default PricingAdmin;
